import query from './query';

export default {
  getCountQuery({ criteria }) {
    const data = query.getParameters({ criteria });
    if (!data || Object.keys(data).length === 0) return {};
    return {
      __args: data,
    };
  },
  getOffersQuery({
    stockScope = {},
    currentPage,
    pageSize,
    sortParams,
  }) {
    const data = query.getParameters({
      criteria: {
        ...stockScope,
        condition: ['New Offer'],
      },
      currentPage,
      pageSize,
      sortParams,
    });

    return {
      __aliasFor: 'getAll',
      __args: data,
      id: true,
      finances: {
        payment: true,
        productType: true,
      },
    };
  },
  getVehiclesQuery({
    criteria,
    currentPage,
    pageSize,
    sortParams,
    fields,
    financesDataContext,
    newFinancesDataContext,
  }) {
    const data = query.getParameters({
      criteria,
      currentPage,
      pageSize,
      sortParams,
      financesDataContext,
      newFinancesDataContext,
    });
    if (!data || Object.keys(data).length === 0) return {};
    return {
      __args: data,
      ...fields,
    };
  },
  getFiltersOptions({ criteria }) {
    const data = query.getParameters({ criteria });
    if (!data || Object.keys(data).length === 0) return {};
    return {
      __args: data,
    };
  },
};
